export enum STORAGE_KEYS {
  LOGIN = 'login',
}
